// Leiste neben dem roten Admin-Banner, solange ein Aivy-Admin das
// Discover-Onboarding in diesem Browser übersprungen hat. Nur unter /discover,
// weil der Skip nur dort etwas sichtbar verändert.
import { useLocation } from 'react-router'

import { useUserContext } from '../../context'
import { useAdminOnboardingSkip } from '../../features/discover/admin-onboarding-skip'

const AdminOnboardingSkipChip = () => {
  const { pathname } = useLocation()
  const { isAdmin, activeSpace } = useUserContext()
  const { reset } = useAdminOnboardingSkip({ isAdmin })

  if (!activeSpace?.onboardingSkippedByAdmin) return null
  if (!pathname.startsWith('/discover')) return null

  return (
    <div
      role='status'
      className='flex flex-wrap items-center justify-between gap-x-4 gap-y-1 bg-yellow-100 px-4 py-1.5 text-xs text-yellow-800'
    >
      <p className='font-medium'>
        Discover-Onboarding für dich übersprungen, nur in diesem Browser.
      </p>
      <button
        type='button'
        onClick={reset}
        className='rounded font-semibold underline-offset-2 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-yellow-800'
      >
        Wieder anzeigen
      </button>
    </div>
  )
}

export default AdminOnboardingSkipChip
